import React, { useContext, useEffect } from "react";
import { FeedbackHero } from "./FeedbackHero";
import { SingleFeedback } from "./SingleFeedback";
import { Button } from "@/components/Button";
import { useTranslation } from "react-i18next";
import { QRFeedbackContextProps } from "@/contexts/QRFeedbackContext/types";
import { QRFeedbackContext } from "@/contexts/QRFeedbackContext";
import { FeedbackFormPreviewProps } from "./types";

export const FeedbackFormPreview = ({ data, isInitPreview }: FeedbackFormPreviewProps) => {
  const { categories, themeColor } = data || {};
  const { t } = useTranslation("feedback");

  const qrFeedbackContextData = useContext<QRFeedbackContextProps>(QRFeedbackContext);
  const { selectedReviewCategory, setSelectedReviewCategoryIndex } = qrFeedbackContextData;

  useEffect(() => {
    if (data?.categories?.length) {
      setSelectedReviewCategoryIndex(0);
    }
  }, [data?.categories, setSelectedReviewCategoryIndex]);

  const activeCategory = selectedReviewCategory ?? data?.categories?.[0];

  return (
    <>
      <FeedbackHero
        data={data}
        isInitPreview={isInitPreview}
      />
      <div className={`feedback-template__content`}>
        <SingleFeedback
          data={data}
          isInitPreview={isInitPreview}
          category={activeCategory}
        />
      </div>
      <div className="feedback-template__buttons feedback-button">
        <Button
          label={t("send_feedback_button_label")}
          dataQA="feedback-submit-button"
          small
          buttonColor={themeColor.buttonColor}
          disabled={categories?.length > 1}
        />
      </div>
    </>
  );
};
